import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import colors from '../theme/colors';
import logo from "../assets/logo.png";


const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/henna', label: 'Henna' },
    { path: '/nail-art', label: 'Nail Art' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/contact', label: 'Contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav style={{ backgroundColor: colors.white, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }} className="sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            {/* <img
              src={logo}
              alt="HennabyAnjali Logo"
              className="h-18 w-40 object-contain"
            /> */}
            <span
              className="text-xl"
              style={{ color: colors.primary }}
            >
              𝐖𝐞𝐥𝐜𝐨𝐦𝐞 𝐭𝐨 𝐇𝐞𝐧𝐧𝐚𝐛𝐲𝐀𝐧𝐣𝐚𝐥𝐢
            </span>

          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                style={{
                  color: isActive(link.path) ? colors.primary : colors.text.medium,
                  borderBottomColor: isActive(link.path) ? colors.highlight : 'transparent'
                }}
                className="text-base font-medium transition-all duration-200 border-b-2 pb-1 hover:opacity-70"
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:+919876543210"
              style={{ backgroundColor: colors.highlight, color: colors.white }}
              className="flex items-center space-x-2 px-5 py-2.5 rounded-full font-medium transition-all duration-200 hover:opacity-90"
            >
              <Phone size={18} />
              <span>Book Now</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            style={{ color: colors.primary }}
            className="md:hidden p-2"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden pb-6">
            <div className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  style={{
                    color: isActive(link.path) ? colors.primary : colors.text.medium,
                    backgroundColor: isActive(link.path) ? colors.background : 'transparent'
                  }}
                  className="text-base font-medium px-4 py-2 rounded-lg transition-all duration-200"
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="tel:+61 468 895 533"
                style={{ backgroundColor: colors.highlight, color: colors.white }}
                className="flex items-center justify-center space-x-2 px-5 py-3 rounded-full font-medium transition-all duration-200"
              >
                <Phone size={18} />
                <span>Book Now</span>
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;